const productMedia = JSON.parse(document.getElementById('product-images-json').textContent);
const variantsMedia = JSON.parse(document.getElementById('variant-images-json').textContent);

class ProductSwiperSlider {
    constructor() {
        this.mainSwiper = null;
        this.thumbsSwiper = null;
        this.currentImages = [];

        // Cache DOM elements to avoid repeated queries
        this.mainWrapper = document.querySelector('.product-main-swiper .swiper-wrapper');
        this.thumbsWrapper = document.querySelector('.product-thumbs-swiper .swiper-wrapper');
        this.thumbsContainer = document.querySelector('.product-thumbs-swiper');

        this.init();
    }

    init() {
        const currentVariantId = this.getCurrentVariantId();

        // Load initial images for the current variant
        this.loadImagesForVariant(currentVariantId);

        // Initialize swipers once
        this.initializeSwipers();

        // Subscribe to variant changes
        this.subscribeToVariantChanges();

        // Sync thumbs width with main image
        this.syncThumbsWidth();
        this.observeMainImage();
    }

    observeMainImage() {
        // Use ResizeObserver to watch for size changes on the main image
        this.resizeObserver = new ResizeObserver(() => {
            this.syncThumbsWidth();
        });

        const mainImage = this.mainWrapper.querySelector('.swiper-slide img');
        if (mainImage) {
            this.resizeObserver.observe(mainImage);
        }
    }

    syncThumbsWidth() {
        const mainImage = this.mainWrapper.querySelector('.swiper-slide img');
        if (mainImage && this.thumbsContainer) {
            const applyWidth = () => {
                const width = mainImage.offsetWidth;
                if (width > 0) {
                    this.thumbsContainer.style.width = width + 'px';
                    if (this.thumbsSwiper) this.thumbsSwiper.update();
                }
            };

            // Wait for image to load to get correct dimensions
            if (mainImage.complete && mainImage.offsetWidth > 0) {
                applyWidth();
            } else {
                mainImage.addEventListener('load', applyWidth, { once: true });
                // Fallback: retry after a short delay in case load event already fired
                setTimeout(() => {
                    if (mainImage.offsetWidth > 0 && this.thumbsContainer.style.width === '0px') {
                        applyWidth();
                    }
                }, 100);
            }
        }
    }

    getCurrentVariantId() {
        const variantInput = document.querySelector('[name="id"]');
        return variantInput ? variantInput.value : null;
    }

    loadImagesForVariant(variantId) {
        let imagesToUse = [];

        if (variantId) {
            // Find variant in variantsMedia
            const variant = variantsMedia.find(v => v.id.toString() === variantId.toString());
            imagesToUse = (variant && variant.images && variant.images.length > 0)
                ? variant.images
                : productMedia;
        } else {
            imagesToUse = productMedia;
        }

        this.currentImages = imagesToUse;

        // Update DOM slides
        this.updateSwiperSlides();

        // Always reset to the first slide after variant change
        if (this.mainSwiper) this.mainSwiper.slideTo(0, 0);
        if (this.thumbsSwiper) this.thumbsSwiper.slideTo(0, 0);

        // Re-observe and sync thumbs width after variant change
        this.observeMainImage();
        this.syncThumbsWidth();
    }

    updateSwiperSlides() {
        this.renderSlides(this.mainWrapper, this.currentImages, true);
        this.renderSlides(this.thumbsWrapper, this.currentImages, false);

        // Update Swiper instances after DOM changes
        if (this.mainSwiper) {
            this.mainSwiper.update();
            if (this.mainSwiper.pagination) this.mainSwiper.pagination.update();
        }
        if (this.thumbsSwiper) {
            this.thumbsSwiper.update();
        }
        // Re-link thumbs to main
        if (this.mainSwiper && this.thumbsSwiper) {
            this.mainSwiper.thumbs.swiper = this.thumbsSwiper;
            this.mainSwiper.thumbs.init();
            this.mainSwiper.thumbs.update();
        }
    }

    // Helper to render slides
    renderSlides(wrapper, images, showEmptyMessage) {
        wrapper.innerHTML = '';

        if (!images.length) {
            if (showEmptyMessage) {
                const slide = document.createElement('div');
                slide.className = 'swiper-slide';
                slide.innerHTML = '<svg viewBox="0 0 512 512"><path d="M485.18 38.815H26.816c-11.476 0-20.813 9.337-20.813 20.815v392.74c0 11.478 9.337 20.815 20.813 20.815H485.18c11.48 0 20.817-9.337 20.817-20.815V59.63c0-11.478-9.337-20.815-20.817-20.815zm9.367 413.555c0 5.164-4.201 9.365-9.367 9.365H26.816c-5.162 0-9.363-4.201-9.363-9.365V59.63c0-5.164 4.201-9.365 9.363-9.365H485.18c5.166 0 9.367 4.201 9.367 9.365z" data-original="#000000"/><path d="M82.949 275.236a5.725 5.725 0 0 0 5.725-5.725v-146.22c0-4.84 3.921-8.778 8.741-8.778h317.171c4.819 0 8.741 3.938 8.741 8.778v145.648a5.725 5.725 0 1 0 11.45 0V123.291c0-11.154-9.057-20.228-20.191-20.228H97.415c-11.133 0-20.191 9.074-20.191 20.228v146.22a5.725 5.725 0 0 0 5.725 5.725z" data-original="#000000"/><path d="M378.799 236.52a21.827 21.827 0 0 0-16.359-7.663c-.082-.002-.168-.002-.253-.002a21.843 21.843 0 0 0-16.281 7.283l-59.156 66.16-91.244-99.414a21.841 21.841 0 0 0-32.607.475l-84.297 97.413a5.719 5.719 0 0 0-1.398 3.746v84.202c0 11.139 9.061 20.2 20.198 20.2h317.189c11.141 0 20.202-9.061 20.202-20.2v-84.468c0-1.362-.485-2.68-1.372-3.716zm44.545 152.199c0 4.825-3.925 8.75-8.752 8.75H97.404c-4.823 0-8.748-3.925-8.748-8.75v-82.068l82.899-95.799a10.275 10.275 0 0 1 7.712-3.591c3.004-.048 5.774 1.152 7.801 3.364l95.519 104.072a5.73 5.73 0 0 0 4.219 1.854h.037a5.725 5.725 0 0 0 4.23-1.908l63.368-70.871c1.998-2.236 4.763-3.554 7.868-3.465a10.39 10.39 0 0 1 7.783 3.645l53.252 62.41z" data-original="#000000"/><path d="M242.321 178.523c0 22.341 18.144 40.518 40.449 40.518 22.341 0 40.516-18.176 40.516-40.518 0-22.302-18.174-40.447-40.516-40.447-22.305.001-40.449 18.145-40.449 40.447zm69.514 0c0 16.027-13.038 29.067-29.065 29.067-15.99 0-28.998-13.04-28.998-29.067 0-15.988 13.008-28.997 28.998-28.997 16.027.001 29.065 13.009 29.065 28.997z"/></svg>';
                wrapper.appendChild(slide);
            }
            return;
        }

        images.forEach((image) => {
            const slide = document.createElement('div');
            slide.className = 'swiper-slide';
            slide.innerHTML = `<img src="${image.src}" alt="${image.alt || 'Image'}" />`;
            wrapper.appendChild(slide);
        });
    }

    initializeSwipers() {
        // Initialize thumbs swiper
        this.thumbsSwiper = new Swiper('.product-thumbs-swiper', {
            spaceBetween: 10,
            slidesPerView: 2,
            watchSlidesProgress: true,
            navigation: {
                nextEl: '.product-thumbs-swiper .swiper-button-next',
                prevEl: '.product-thumbs-swiper .swiper-button-prev',
            },
            breakpoints: {
                768: {
                    slidesPerView: 4,
                    spaceBetween: 23,
                }
            },
        });

        // Initialize main swiper
        this.mainSwiper = new Swiper('.product-main-swiper', {
            spaceBetween: 20,
            thumbs: {
                swiper: this.thumbsSwiper,
            },
            keyboard: {
                enabled: true,
            },
            loop: false,
            pagination: {
                el: ".product-main-swiper .swiper-pagination",
                clickable: true,
            },
        });
    }

    subscribeToVariantChanges() {
        // Listen for native input changes
        document.addEventListener('change', (e) => {
            if (e.target.name === 'id') {
                this.loadImagesForVariant(e.target.value);
            }
        });

        // Listen for Shopify's pub/sub events
        if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
            subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
                if (event.data?.variant) {
                    this.loadImagesForVariant(event.data.variant.id);
                }
            });
        }
    }
}

// Initialize swiper slider
document.addEventListener('DOMContentLoaded', () => {
    new ProductSwiperSlider();
});